<template>
    <div class="w-100">
        <div class="row w-100 mx-0">
            <div class="col-12 dealColumn crm-modal-header" style="border-bottom:1px solid #dcdddd">
                <div class="contactDetail">
                    <div class="crm-modal-header hpx-50 d-flex align-items-center justify-content-between col-12 px-0" v-if="field!=='dealCard'" @click="toggleClick('contactDetailToggle')" >
                        <label class="m-0 align-self-center f-14 f-w-normal">{{$ml.get('PERSON_DETAILS')}} </label>
                        <i class="fa fa-edit color-gray f-20 cursor-pointer editContact d-none" @click="$emit('editContact')"></i>
                    </div>
                    <div class="col-12 mt-3" v-else>
                        <button type="button" @click="editRelationship('deal')" data-toggle="modal" data-target="#relationship" class="btn bg-new-primary f-14">
                            <i class="fa fa-exchange f-14 mr-2"></i> {{$ml.get('CHANGE_PERSON')}}
                        </button>  
                        <hr>
                    </div>
                </div> 
            </div>
            <div v-if="data!==undefined && data!=null" class="col-12 f-12 bg-white" id="contactDetailToggle" :style="windowWidth<maxMobilSize ? {display:'none'}:{}">

                <div class="py-2 mb-2" v-if="data.n!==undefined && data.n!=='' && data.n!=null">
                    <span class="color-gray">{{$ml.get('NAME')}}</span>
                    <span class="d-block">{{data.n}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.sn!==undefined && data.sn!=='' && data.sn!=null">
                    <span class="color-gray">{{$ml.get('SURNAME')}}</span>
                    <span class="d-block">{{data.sn}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.gsm!==undefined && data.gsm!=='' && data.gsm!=null && typeof(data.gsm)=='string'">
                    <span class="color-gray">GSM</span>
                    <div class="d-block call mt-1" @click="makeCall(data.gsm)">
                        <i class="fas fa-phone-alt"></i>
                        <span>{{data.gsm}}</span>
                    </div>
                </div>
                <div class="py-2 mb-2" v-else>
                    <span class="color-gray">GSM</span>
                    <div class="d-block call mt-1" @click="makeCall(i)" v-for="(i, index) in data.gsm" v-bind:key="index">
                        <i class="fas fa-phone-alt"></i>
                        <span class="pl-1">{{i}}</span>
                    </div>  
                </div>

                
                <div class="py-2 mb-2" v-if="data.email!==undefined && data.email!=='' && data.email!=null && typeof(data.email)=='string'">
                    <span class="color-gray">{{$ml.get('EMAIL')}}</span>
                    <span class="d-block">{{data.email}}</span>
                </div>
                    <div class="py-2 mb-2" v-else>
                    <span class="color-gray">{{$ml.get('EMAIL')}}</span>
                    <span class="d-block" v-for="(i,index) in data.email" v-bind:key="index">{{i}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.tck!==undefined && data.tck!=='' && data.tck!=null">
                    <span class="color-gray">{{$ml.get('TCK')}}</span>
                    <span class="d-block">{{data.tck}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.phone!==undefined && data.phone!=='' && data.phone!=null  && typeof(data.phone)=='string'">
                    <span class="color-gray">{{$ml.get('LANDLINE')}}</span>
                    <span class="d-block">{{data.phone}}</span>
                </div>
                <div class="py-2 mb-2" v-else>
                    <span class="color-gray">{{$ml.get('LANDLINE')}}</span>
                    <span class="d-block" v-for="(i,index) in data.phone" v-bind:key="index">{{i}}</span>
                </div>
                

                <div class="py-2 mb-2" v-if="data.fax!==undefined && data.fax!=='' && data.fax!=null && typeof(data.fax)=='string'">
                    <span class="color-gray">{{$ml.get('FAX')}}</span>
                    <span class="d-block" >{{data.fax}}</span>
                </div>
                    <div class="py-2 mb-2" v-else>
                    <span class="color-gray">{{$ml.get('FAX')}}</span>
                    <span class="d-block" v-for="(i,index) in data.fax" v-bind:key="index">{{i}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.addr!==undefined && data.addr!=='' && data.addr!=null">
                    <span class="color-gray">{{$ml.get('ADDRESS')}}</span>
                    <span class="d-block">{{data.addr}}</span>
                </div>
                

                <div class="py-2 mb-2" v-if="data.country!==undefined && data.country!=='' && data.country!=null">
                    <span class="color-gray">{{$ml.get('COUNTRY')}}</span>
                    <span class="d-block">{{data.country}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.city!==undefined && data.city!=='' && data.city!=null">
                    <span class="color-gray">{{$ml.get('CITY')}}</span>
                    <span class="d-block">{{data.city}}</span>
                </div>

                <div class="py-2 mb-2" v-if="data.town!==undefined && data.town!=='' && data.town!=null">
                    <span class="color-gray">{{$ml.get('DISTRICT')}}</span>
                    <span class="d-block">{{data.town}}</span>
                </div>
            </div>
            <div v-else class="bg-white px-2 pt-2">
                <label class="p-1 font-family-bold f-14 f-w-normal">{{$ml.get('NOT_FOUND_PERSON')}}!</label>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'
import {mapActions} from 'vuex'
import CountrySelect from '@/components/country-select'
import RegionSelect from '@/components/region-select'

export default {
    name: 'contactDetailPanel',
    components:{
        CountrySelect,
        RegionSelect
    },
    data () {
        return {

        }
    },
    computed: {
        ...mapState(['baseUrl','cityList','townList','windowWidth','maxMobilSize','maxTabletSize']),
    },
    props:["data","type","field","user","permission"],
    methods:{

        toggleClick(id){
            if(this.windowWidth<this.maxMobilSize){
                $("#"+id).slideToggle();
            }
        },
        makeCall(gsm){
            gsm = gsm.toString()
            var tel = "90" + gsm.substring(gsm.length - 10)
            this.$root.$refs.sip.call(tel)
        },
        ...mapActions([
            'editRelationship',
            'updateLoading'
        ]),
    },
    created(){
    },
    watch:{
        data:function(value){
            if(value.country!==undefined){
                this.country=value.country
                if(this.country=="Turkey" || this.country=="Türkiye"){
                    this.isTurkeyCountry=true;
                }else{       
                    this.isTurkeyCountry=false;
                }
            }
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.contactDetail:hover .editContact{
    display: block !important;
}
.iptal:before{
    color:red
}
.updateInput{
    border: 0px;
    border-bottom: 1px solid #66D0FF80;
}
.add{
    color: #3767a0;
}
.add,.edit:hover{
    cursor: pointer;
}
.add:hover:after{
    content: "\e952";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #66D0FF;
}
.edit:hover:after{
    content: "\e913";
    font-size: 14px;
    margin-left: 0.5em;
    font-family: 'icomoon' !important;
    color: #66D0FF;
}
.call{
    max-width: 155px;
    border: 1px solid #E4E5E6;
    cursor: pointer;
}
.fa-phone-alt{
    background: #E4E5E6;
    padding: 0.3rem;
    color: #53565E;
}
</style>
